import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Headers, Http, Response } from '@angular/http';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import { UserService } from 'app/shared/services/User/user.service';
import { AppUser } from 'app/models/app-user';
import { GroupObject } from 'app/models/group';
import { GameObject } from 'app/models/draft';
import { environment } from 'environments/environment';

@Injectable()
export class GroupService {
  user: AppUser;
  user$: Observable<AppUser>;
  selectedTickets: GameObject[];
  currentGroup: GroupObject;

  constructor(
    private userService: UserService,
    private http: Http
  ) {
    this.userService.get().subscribe(user => {
      // this isnt always in sync
      this.user = user;
    });
  }

  getGroups() {
    const url = environment.API_BASE_URL + '/onboarding/groups';
    const userParams = new FormData();
    const headers = new Headers();
    headers.append('token', this.userService.user.token);
    return this.http.post(url, userParams, { headers: headers }).map(res => res.json())
      .catch(this.handleError);
  }

  getGroupMembers(groupId) {
    const url = `${environment.API_BASE_URL}/onboarding/groups/groupMembers?groupId=${groupId}`;
    return this.http.get(url).map(res => res.json())
      .catch(this.handleError);
  }

  getGroupsAndReservations() {
    const url = environment.API_BASE_URL + '/onboarding/groups/indexv2';
    const userParams = new FormData();
    const headers = new Headers();
    headers.append('token', this.userService.user.token);
    return this.http.post(url, userParams, { headers: headers }).map(res => res.json())
      .catch(this.handleError);
  }

  private handleError(error: Response) {
    return Observable.throw(error.json().error || 'Server Error');
  }

  refreshGroup(groupID) {
    const url = environment.API_BASE_URL + '/onboarding/groups/refresh';
    const headers = new Headers();
    headers.append('token', this.userService.user.token);
    const userParams = new FormData();
    userParams.append('group_id', groupID);
    return this.http.post(url, userParams, { headers: headers }).map(res => {
      this.currentGroup = new GroupObject(res.json().group);
      return this.currentGroup;
    })
      .catch(this.handleError);
  }

  getDraftSchedule(group_id) {
    const url = environment.API_BASE_URL + '/onboarding/groups/schedule';
    const headers = new Headers();
    const userParams = new FormData();
    headers.append('token', this.userService.user.token);
    userParams.append('group_id', group_id);
    return this.http.post(url, userParams, { headers: headers }).map(res => {
      return res.json();
    })
      .catch(err => {
        return Observable.throw(err.json());
      });
  }

  inviteGroupMemberByPhone(data, group_id) {
    const url = environment.API_BASE_URL + '/Contacts/invite';
    const headers = new Headers();
    const userParams = new FormData();
    headers.append('token', this.userService.user.token);
    userParams.append('first_name', data.fname);
    userParams.append('last_name', data.lname);
    userParams.append('phone_number', data.number);
    userParams.append('group_id', group_id);

    return this.http.post(url, userParams, { headers: headers }).map(res => {
      return res;
    })
      .catch(err => {
        return Observable.throw(err.json());
      });
  }

  saveDraftTime(group_id, tstamp) {
    const url = environment.API_BASE_URL + '/onboarding/groups/save_schedule';
    const headers = new Headers();
    const userParams = new FormData();
    headers.append('token', this.userService.user.token);
    userParams.append('group_id', group_id);
    userParams.append('sched_tstamp', tstamp);
    return this.http.post(url, userParams, { headers: headers }).map(res => res.json())
      .catch(err => {
        console.log(err);
        return Observable.throw(err.json());
      });
  }

  isValidGroup(groupCode) {
    const url = environment.API_BASE_URL + '/onboarding/groups/isValid';
    const headers = new Headers();
    const userParams = new FormData();
    headers.append('token', this.userService.user.token);
    userParams.append('group_code', groupCode);
    return this.http.post(url, userParams, { headers: headers }).map((res: Response) => {
      return res.json();
    })
      .catch(err => {
        console.log(err);
        return Observable.throw(err.json());
      });
  }
  isValidGroupv2(groupCode) {
    const url = environment.API_BASE_URL + '/onboarding/groups/isValidv2';
    const headers = new Headers();
    const userParams = new FormData();
    headers.append('token', this.userService.user.token);
    userParams.append('group_code', groupCode);
    return this.http.post(url, userParams, { headers: headers }).map((res: Response) => {
      return res.json();
    })
      .catch(err => {
        console.log(err);
        return Observable.throw(err.json());
      });
  }

  getPublicGroups(team_id) {
    const url = environment.API_BASE_URL + '/PublicGroup/v2';
    const userParams = new FormData();
    const headers = new Headers();
    headers.append('token', this.userService.user.token);
    userParams.append('team_id', team_id);
    return this.http.post(url, userParams, { headers: headers }).map(res => res.json())
      .catch(err => {
        return Observable.throw(err.json());
      });
  }

  getGroupDetails(groupId) {
    let url; 
    if(this.userService.isLoggedIn()){
      url = environment.API_BASE_URL + '/onboarding/groups/detailsv2';
    } else {
      url = environment.API_BASE_URL + '/onboarding/groups/details';
    }
    const userParams = new FormData();
    const headers = new Headers();
    userParams.append('group_id', groupId);
    headers.append('token', this.userService.user.token);
    return this.http.post(url, userParams, { headers: headers }).map(res => res.json())
      .catch(err => {
        return Observable.throw(err.json());
      });
  }

  getGroupID() {
    return this.currentGroup.group_id;
  }
  getCurrentGroup() {
    return this.currentGroup;
  }
  inviteGroupMemberByEmail(email, groupID) {
    alert(email);
    alert(groupID);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/SS-Groups/groups.service.ts